(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/hooks/assets/javascripts/use-casino-display-size.js') >= 0) return;  svs.modules.push('/components/casino-react/hooks/assets/javascripts/use-casino-display-size.js');

'use strict';

const CasinoDisplaySize = svs.components.casino_react.common.constants.CasinoDisplaySize;
const useMediaQueryWatcher = svs.components.lbUtils.useMediaQuery.useMediaQueryWatcher;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  BREAKPOINT_XS = _svs$components$lbUti.BREAKPOINT_XS,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM,
  BREAKPOINT_AM = _svs$components$lbUti.BREAKPOINT_AM,
  BREAKPOINT_MD = _svs$components$lbUti.BREAKPOINT_MD,
  BREAKPOINT_LG = _svs$components$lbUti.BREAKPOINT_LG,
  BREAKPOINT_XL = _svs$components$lbUti.BREAKPOINT_XL;
const useCasinoDisplaySize = () => {
  const breakpoint = useMediaQueryWatcher();
  switch (breakpoint) {
    case BREAKPOINT_XS:
    case BREAKPOINT_SM:
    case BREAKPOINT_AM:
      return CasinoDisplaySize.SMALL;
    case BREAKPOINT_MD:
      return CasinoDisplaySize.MEDIUM;
    case BREAKPOINT_LG:
    case BREAKPOINT_XL:
    default:
      return CasinoDisplaySize.LARGE;
  }
};
setGlobal('svs.components.casino_react.hooks.useCasinoDisplaySize', useCasinoDisplaySize);

 })(window);